import React from 'react';
import { Card } from '@mui/material';
import OverlayLoader from '../OverlayLoader';

export const BaseCard = ({ children, noShadow = false, ...rest }) => (
  <Card square elevation={noShadow ? 0 : 24} {...rest}>
    {children}
  </Card>
);

export const DashboardTableCard = ({ children, isLoading = false, ...rest }) => (
  <Card
    sx={{
      '& * .MuiCardHeader-root': {
        borderBottom: '1px solid rgba(32,39,140,.125)',
      },
    }}
    square
    elevation={25}
    {...rest}
  >
    <OverlayLoader isLoading={isLoading}>{children}</OverlayLoader>
  </Card>
);
